/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateServiceVersionDto
 */
export interface UpdateServiceVersionDto {
    /**
     * The YAML definition.
     * @type {string}
     * @memberof UpdateServiceVersionDto
     */
    definition: string;
    /**
     * The environment settings.
     * @type {{ [key: string]: string; }}
     * @memberof UpdateServiceVersionDto
     */
    environment: { [key: string]: string; };
    /**
     * Indicates if the version is active.
     * @type {boolean}
     * @memberof UpdateServiceVersionDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the UpdateServiceVersionDto interface.
 */
export function instanceOfUpdateServiceVersionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "definition" in value;
    isInstance = isInstance && "environment" in value;
    isInstance = isInstance && "isActive" in value;

    return isInstance;
}

export function UpdateServiceVersionDtoFromJSON(json: any): UpdateServiceVersionDto {
    return UpdateServiceVersionDtoFromJSONTyped(json, false);
}

export function UpdateServiceVersionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateServiceVersionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'definition': json['definition'],
        'environment': json['environment'],
        'isActive': json['isActive'],
    };
}

export function UpdateServiceVersionDtoToJSON(value?: UpdateServiceVersionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'definition': value.definition,
        'environment': value.environment,
        'isActive': value.isActive,
    };
}

